import { Box, Typography, Grid } from '@mui/material';
import { generateAvailableSlots, getDurationMinutes } from './bookingSlotUtils';

const BookingSchedule = ({ selectedTime, onTimeSelect, hideContainer = false, service, selectedDate, bookedSlots = [], error = false }) => {
  const duracionMinutos = getDurationMinutes(service?.duracionEstimada, service?.unidadDuracion);
  const slots = generateAvailableSlots(selectedDate, service?.disponibilidad, duracionMinutos, bookedSlots);
  const faltaHorario = error && !selectedTime;

  const content = (
    <>
      <Typography variant="subtitle2" fontWeight="bold" color={faltaHorario ? 'error.oscuro' : 'primary.main'} sx={{ mb: faltaHorario ? 0.5 : 2 }}>
        Horario
      </Typography>
      {faltaHorario && (
        <Typography variant="caption" color="error.oscuro" sx={{ display: 'block', fontWeight: 600, mb: 1.5 }}>
          Selecciona un horario para continuar.
        </Typography>
      )}

      {slots.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {!service?.disponibilidad?.length
            ? 'El proveedor no ha configurado su disponibilidad.'
            : 'No hay horarios disponibles para este día.'}
        </Typography>
      ) : (
        <Grid container spacing={1}>
          {slots.map(({ label, value }) => {
            const isSelected = selectedTime === value;
            return (
              <Grid size={6} key={value}>
                <Box
                  onClick={() => onTimeSelect(value)}
                  sx={{
                    p: 1.5,
                    borderRadius: '12px',
                    border: '1px solid',
                    borderColor: isSelected ? 'secondary.main' : 'sutil',
                    textAlign: 'center',
                    cursor: 'pointer',
                    // El elegido, relleno del azul medio con el texto en el azul oscuro, como el día elegido del calendario (el azul
                    // medio como letra sobre blanco daba 2.9:1)
                    color: 'primary.main',
                    bgcolor: isSelected ? 'secondary.main' : 'white',
                    transition: '0.3s',
                    '&:hover': { borderColor: 'secondary.main', bgcolor: isSelected ? 'secondary.main' : 'grey.50' }
                  }}
                >
                  <Typography variant="body2" fontWeight="bold">{label}</Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </>
  );

  if (hideContainer) return content;

  return <Box sx={{ p: 3 }}>{content}</Box>;
};

export default BookingSchedule;
